export const SELF_PICKUP_LABEL = "Self Pickup";

export function orderLandmark(order) {
  return !order?.self_pickup && order?.address ? order.address.land_mark : "";
}

export function orderAddressLine(order) {
  if (order?.self_pickup) return SELF_PICKUP_LABEL;
  return order?.address ? order.address.address1.slice(0, 70) : "......";
}
